// CP2 — Referral capture + redirect
import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Seo from "../components/Seo";

const API = process.env.REACT_APP_BACKEND_URL || "";

function setRefCookie(code) {
  try {
    const maxAge = 60 * 60 * 24 * 30; // 30 days
    document.cookie = `sb_ref=${encodeURIComponent(code)}; max-age=${maxAge}; path=/; SameSite=Lax`;
  } catch {}
}

export default function ReferralRedirect({ target }) {
  const { code } = useParams();
  const nav = useNavigate();

  useEffect(() => {
    const c = (code || "").toUpperCase();
    if (c) setRefCookie(c);
    // Fire-and-forget track click; never leak validity
    fetch(`${API}/api/referrals/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code: c, event_source: "link" }),
    }).catch(() => {});
    // Immediately redirect regardless of code validity
    const t = setTimeout(() => nav(target || "/scouts", { replace: true }), 350);
    return () => clearTimeout(t);
  }, [code, nav, target]);

  return (
    <div className="min-h-screen bg-[#080B0D] flex items-center justify-center text-[#A1A1AA] text-sm">
      <Seo title="Redirecting" description="Referral redirect." path={target || "/scouts"} noindex />
      Redirecting…
    </div>
  );
}
